import { isAxiosError } from 'axios'

import { isSensitiveLoginExpiredAxiosError } from '../../api'
import { HTTP_STATUS_CODE_UNAUTHORIZED } from '../../http'

export const directContactFormErrorIsAuthenticationError = (
  error: unknown,
): boolean =>
  isSensitiveLoginExpiredAxiosError(error) ||
  (isAxiosError(error) &&
    (error.status === HTTP_STATUS_CODE_UNAUTHORIZED ||
      error.response?.status === HTTP_STATUS_CODE_UNAUTHORIZED))
